import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"pointer",style:({
        opacity: (_vm.loading)?0.5:1
      }),on:{"click":_vm.onChange}},[_c(VIcon,{attrs:{"color":_vm.isOk?'success':'gray',"small":_vm.small}},[_vm._v("mdi-account-check-outline")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }